<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <bannerlisttab />
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow class="row-header">
            <div class="button button-icon button-orange" @click="setIsBannerModalShow()">
              ADD BANNER
              <img src="@/assets/images/admin/Plus.svg" class="icon" />
            </div>
          </CRow>
          <CRow>
            <CCol>
              <CDataTable responsive :items="items" :fields="fields" column-filter pagination>
                <template #status="{item}">
                  <td>
                    <div
                      style="font-weight: bold"
                      :style="getStatusColor(item.status)"
                    >{{(item.status).toUpperCase()}}</div>
                  </td>
                </template>
                <template #action>
                  <td>
                    <div class="view-action">View</div>
                  </td>
                </template>
              </CDataTable>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </CRow>
    <BannerModal :modalVisible="isBannerModalShow" :setModalVisible="setIsBannerModalShow" />
  </CContainer>
</template>

<script>
import bannerlisttab from "./bannerlisttab";
import BannerModal from "../../modal/BannerModal";

const items = [
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Showing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Waiting"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Queing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Expired"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Showing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Waiting"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Queing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Expired"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Showing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Waiting"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Queing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Expired"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Showing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Waiting"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Queing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Expired"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Showing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Waiting"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Queing"
  },
  {
    num: "00",
    title: "0000000000",
    str_date: "00/00/0000 00:00",
    end_date: "00/00/0000 00:00",
    click: "000",
    status: "Expired"
  }
];

const fields = [
  { key: "num", label: "NUM", sorter: false, filter: false },
  { key: "title", label: "TITLE" },
  { key: "str_date", label: "START DATE" },
  { key: "end_date", label: "END DATE" },
  { key: "click", label: "CLICK" },
  { key: "status", label: "STATUS" },
  { key: "action", label: "ACTION" }
];

export default {
  name: "bannerlist",
  components: {
    bannerlisttab,
    BannerModal
  },
  data() {
    return {
      isBannerModalShow: false,
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      fields
    };
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case "Showing":
          return "color: #0BB190";
        case "Waiting":
          return "color: #F2DE79";
        case "Expired":
          return "color: #F27979";
      }
    },
    setIsBannerModalShow() {
      this.isBannerModalShow = !this.isBannerModalShow;
    }
  }
};
</script>
